<script>

import { ref , onMounted , reactive } from 'vue';
import { useContextStore } from '../js/contextStore.js';
import { prettyPhone } from "../js/lib";

export default {

    props : [ 'value' ] ,

    setup( props ){

        const map = ref( null );
        const contextStore = useContextStore();
        const shops = ref( [] );
        const shop = ref( {} );
        const city = ref( {} );
        const cities = ref( [] );

        let objectManager;
        let myMap;

        function setCity( data ){
            city.value = data;
            objectManager.setFilter( ( item ) => !data || item.city_id === data.id );
            applyBounds();
        }

        function cityHasShop( city ){
            return shops.find( shop => shop.city_id === city.id );
        }

        function setShop( id ){
            // меняем иконки меток
            objectManager.objects.getAll().forEach(
                item => {
                    if( item.id === id ){

                        shop.value = shops.value.find( item => item.id === id );
                        props.value.data = shop.value;

                        objectManager.objects.setObjectOptions(
                            id ,
                            {
                                preset : 'islands#redShoppingIcon'
                            }
                        );

                        setCity( cities.value.find( city_item => city_item.id === item.city_id ) );

                    }else{
                        objectManager.objects.setObjectOptions(
                            item.id ,
                            {
                                preset : 'islands#nightShoppingIcon'
                            }
                        );
                    }

                }
            )
            // устанавливаем центр карты на метку
            // задаем масштаб 14
            // myMap.balloon.close()
        }

        function applyBounds(){
            let items_count = objectManager.objects.getAll().filter( item => !objectManager.getObjectState( item.id ).isFilteredOut ).length;
            myMap.setBounds( myMap.geoObjects.getBounds() , { checkZoomRange : true } ).then(
                () => {
                    if( items_count <= 1 ){
                        myMap.setZoom( 16 );
                    }
                }
            );
        }

        onMounted( () => ymaps.ready( initMap ) );

        function getCities(){

        }
        async function initMap(){

            let temp = await contextStore.getShops();

            shops.value = temp.shops.filter( shop => shop.is_pickpoint );
            cities.value = temp.cities.filter( city => shops.value.find( shop => shop.city_id === city.id ) );

            objectManager = new ymaps.ObjectManager(
                {
                    clusterize : false ,
                    gridSize : 32 ,
                    zoomMargin : 100 ,
                    clusterDisableClickZoom : false
                }
            );

            objectManager.objects.options.set( 'preset' , 'islands#nightShoppingIcon' );
            objectManager.clusters.options.set( 'preset' , 'islands#nightClusterIcons' );
            objectManager.events.add( 'click' , ( e ) => setShop( e.get( 'objectId' ) ) );

            let lon_max = 0;
            let lon_min = 0;
            let lat_max = 0;
            let lat_min = 0;

            shops.value.forEach(
                item => {

                    if( !item.is_pickpoint ){
                        return;
                    }

                    lon_max = Math.max( lon_max ? lon_max : item.lon , item.lon );
                    lon_min = Math.min( lon_min ? lon_min : item.lon , item.lon );
                    lat_max = Math.max( lat_max ? lat_max : item.lat , item.lat );
                    lat_min = Math.min( lat_min ? lat_min : item.lat , item.lat );

                    objectManager.add(
                        {
                            type : "Feature" ,
                            id : item.id ,
                            city_id : item.city_id ,
                            geometry : {
                                type : "Point" ,
                                coordinates : [ item.lat , item.lon ]
                            }
                        }
                    );
                }
            )

            myMap = new ymaps.Map(
                map.value ,
                {
                    center : [ ( lat_max + lat_min ) / 2 , ( lon_max + lon_min ) / 2 ] ,
                    zoom : 10 ,
                    controls : [
                        'geolocationControl'
                        , 'zoomControl'
                        , 'typeSelector'
                        // , 'fullscreenControl'
                    ]
                }
            );

            myMap.geoObjects.add( objectManager );
            applyBounds();

        }

        return {
            map ,
            shops ,
            cities ,
            city ,
            shop ,

            setCity


        }
    }
}

</script>

<template>
    <div class="delivery-shop">
        <div
            class="delivery-shop-info"
            v-show="shop?.name"
        >
            <div class="delivery-shop-info__name">{{ shop.name }}</div>
            <div class="delivery-shop-info__address">{{ shop.address }}</div>
            <div class="delivery-shop-info__workhours">{{ shop.workhours }}</div>
        </div>
        <div class="delivery-shop__choose">
            <div class="delivery-shop-cities">
                <div
                    class="delivery-shop-cities__city  font-s"
                    v-bind:class="{ 'active' : !city?.name }"
                    v-on:click="setCity()"
                >
                    Все
                </div>
                <div
                    class="delivery-shop-cities__city font-s"
                    v-for="item_city in cities"
                    v-on:click="setCity( item_city )"
                    v-bind:class="{ 'active' : item_city.name === city?.name }"
                >
                    {{ item_city.name }}
                </div>
            </div>
            <div class="delivery-shop__title">
                Выберите магазин на карте
            </div>
            <div class="delivery-shop__map" ref="map"></div>
        </div>
    </div>
</template>

<style scoped>
.delivery-shop__title {
    margin-top: 20px;
}

.delivery-shop-info {
    margin: 20px 0;
    font-weight: bold;
}

.delivery-shop__choose {
    margin-top: 20px;
}

.delivery-shop-cities {
    margin: 15px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
}

.delivery-shop-cities__city {
    flex: 0 0 auto;
    padding-left: 15px;
    padding-right: 15px;
    line-height: 2em;
    border-radius: 1em;
    color: var(--color-granite);
    background-color: var(--color-periwinkle-crayola);
}

.delivery-shop-cities__city.active {
    color: var(--color-periwinkle-crayola);
    background-color: var(--color-granite);
}

.delivery-shop__map {
    display: block;
    aspect-ratio: 16 / 9;
}

.delivery-shop__title {
    margin-top: 20px;
}
</style>
